import { useTranslation } from 'hooks';
import { FC, ReactNode } from 'react';
import Button from 'shared/ui/button/button';
import { Modal } from 'shared/ui/modal/modal';
import { ModalActions } from 'shared/ui/modal/modal-actions/modal-actions';
import cls from './cancelSubscriptionModal.module.scss';

interface CancelModalProps {
  isOpen: boolean;
  description: ReactNode;
  cancelText: string;
  action: string;
  onClose: () => void;
  onClickCancel: () => void;
  onClickAction: () => void;
}

export const CancelSubscriptionModal: FC<CancelModalProps> = ({
  isOpen,
  description,
  cancelText,
  action,
  onClose,
  onClickCancel,
  onClickAction,
}) => {
  const { t } = useTranslation();

  return (
    <Modal width={450} isOpen={isOpen} onClose={onClose} className={cls.modal}>
      <h3>{t('cancelSubscriptionHeading')}</h3>
      <p>{description}</p>
      <ModalActions>
        <Button theme='text' tone='default' onClick={onClickCancel}>
          {cancelText}
        </Button>
        <Button theme='filled' tone='default' onClick={onClickAction}>
          {action}
        </Button>
      </ModalActions>
    </Modal>
  );
};
